import { render, staticRenderFns } from "./VImage.vue?vue&type=template&id=e138c2c6&"
import script from "./VImage.vue?vue&type=script&setup=true&lang=ts&"
export * from "./VImage.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./VImage.vue?vue&type=style&index=0&id=e138c2c6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports